<template>
  <ColumnContent :title="transDynamic(context.spec, `name,${language},${needTranslate}`)">
    <a
      v-for="town in context.towns"
      :key="town.translit"
      class="d-table text--text link-decoration-none mb-4 text-body-1"
      data-qa="doctor-specialty-list"
      :href="reverseFullL10N({ name: 'doctorlist', args: { twn: town.translit, translit: context.spec.translit, language: urlLang } })"
    >
      {{ transDynamic(town, `name,${language},${needTranslate}`) }}
    </a>
  </ColumnContent>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore, useURLStore } from 'src/store'
import { ColumnContent } from 'src/layouts'
import { ContextStore } from 'src/components/pages/vrach/[speciality]/types'

// @ts-ignore
const { context, urlLang }: ContextStore = useContextStore()
const { reverseFullL10N } = useURLStore()

const { language } = I18NextVue
const needTranslate = context.feature_flags.pd_l10n_footer_pages
</script>
